import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TicketContent from "../../components/PrintTicket/TicketContent";
import { getOrderById } from "../../services/orders";
import { getTicketData } from "../../services/ticket";
import api from "../../services/api";

const PrintTicketPage = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [customTicketMessage, setCustomTicketMessage] = useState("");
  const [ticketFontStyle, setTicketFontStyle] = useState(null);

  const fetchTicketData = async (_order) => {
    const userId = _order?.userId;
    if (!userId) return;
    const ticketData = await getTicketData(userId);
    if (ticketData) {
      setCustomTicketMessage(ticketData.text || "");
      setTicketFontStyle({
        fontFamily: ticketData.fontFamily || "Arial",
        fontSize: ticketData.fontSize || 14,
        fontWeight: ticketData.fontWeight || "normal",
      });
    }
  };

  useEffect(() => {
    const fetchOrder = async () => {
      // 1. Try sessionStorage
      const sessionOrder = window.sessionStorage.getItem("printOrder");

      if (sessionOrder) {
        try {
          const parsed = JSON.parse(sessionOrder);
          if (parsed && parsed._id === orderId) {
            // Fetch ticket styling
            setOrder(parsed);
            fetchTicketData(parsed);
            return;
          }
        } catch (e) {}
      }
      // 2. Try local DB
      try {
        const localOrder = await getOrderById(orderId);
        if (localOrder) {
          // Fetch ticket styling
          setOrder(localOrder);
          fetchTicketData(localOrder);
          return;
        }
      } catch (e) {
        console.warn("Could not fetch order:", e);
      }

      // 3. Fallback to API
      try {
        const response = await api.get(`/orders/${orderId}`);
        const apiOrder = response?.data;
        if (apiOrder && apiOrder._id) {
          // Fetch ticket styling
          setOrder(apiOrder);
          fetchTicketData(apiOrder);
        } else {
          setOrder(null);
        }
      } catch (e) {
        setOrder(null);
      }
      
    };
    fetchOrder();
  }, [orderId]);

  useEffect(() => {
    if (order && order._id && ticketFontStyle) {
      const closeAfterPrint = () => {
        // window.sessionStorage.removeItem("printOrder");
        // window.close();
        // setTimeout(() => {
        //   if (!window.closed) {
        //     document.body.innerHTML = "<h2>Puedes cerrar esta pestaña.</h2>";
        //   }
        // }, 500);
      };
      window.onafterprint = closeAfterPrint;
      setTimeout(() => {
        window.print();
        closeAfterPrint();
      }, 300);
      return () => {
        window.onafterprint = null;
      };
    }
  }, [order, ticketFontStyle]);
  if (!order || !ticketFontStyle) return <div>Cargando ticket...</div>;
  const resolveTicketDate = (o) => {
    const primary = o?.createdAt || o?.created_at || null;
    const fallback = o?.updatedAt || o?.updated_at || null;
    const fromObjectId = (() => {
      const id = o?._id;
      if (typeof id !== "string" || id.length < 8) return null;
      const hex = id.substring(0, 8);
      const seconds = parseInt(hex, 16);
      if (!Number.isFinite(seconds)) return null;
      return new Date(seconds * 1000);
    })();
    const dateCandidate = primary || fallback || fromObjectId;
    const d = dateCandidate ? new Date(dateCandidate) : null;
    return d && !isNaN(d.getTime())
      ? d.toLocaleString("es-MX")
      : new Date().toLocaleString("es-MX");
  };
  const ticketDateString = resolveTicketDate(order);
  return (
    <div
      style={{
        background: "white",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <TicketContent
        page={{ title: order.storeName }}
        tickedCustomMessage={customTicketMessage}
        ticketFontStyle={ticketFontStyle}
        internalName={order.customerName || order.name}
        paymentMethod={order.paymentMethod}
        details={false}
        editDetails=""
        setEditDetails={() => {}}
        printing={true}
        currentProducts={order.products || []}
        total={
          order.variable
            ? order.total
            : (order.products || []).reduce(
                (acc, item) =>
                  acc +
                  (Number(item.price || 0) * Number(item.quantity || 0) -
                    Number(item.discount || 0)),
                0
              )
        }
        payment={order.payment || 0}
        creditDetails={order.creditDetails}
        orderId={order._id}
        pendingOrderData={order.pendingOrder}
        ticketDate={ticketDateString}
      />
    </div>
  );
};

export default PrintTicketPage;
